export default {
  path: '/userProtocol/:type',
  meta: {
    isLogin: false
  },
  component: () => import('@/views/userProtocol/IndexView.vue'),
}